<template>
  <div>
    <v-card v-if="dataOnlyZeros === 0" class="mb-4">
      <v-card-title class="pt-4">
        <v-container class="pa-0" fluid fill-height>
          <span class="pa-1 title">Dia da semana</span>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-layout class="pb-4" justify-center>
          <span class="body-2">Não há dados</span>
        </v-layout>
      </v-card-text>
    </v-card>
    <chart-card v-else title="Dia da semana" :data="chartData" :controls="false" :loader="loader" is-integer />
  </div>
</template>

<script>
import { orderBy, cloneDeep } from 'lodash'
import ChartCard from '@/components/ChartCard.vue'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  props: {
    data: Array,
    module: String,
  },
  computed: {
    loader() {
      if (this.module === 'clientes') return ['clientes-dias-semana-maiores-compras']
      if (this.module === 'produtos') return ['produtos-dias-semana-maiores-compras']
      return ''
    },
    dataOnlyZeros() {
      return this.data.reduce((accum, object) => {
        return accum + object['NUM_TOTAL_CUPONS']
      }, 0)
    },
    dataFormatada() {
      return cloneDeep(orderBy(this.data, 'NUM_DIA_SEMANA', 'asc')).map((obj) => {
        switch (obj['NUM_DIA_SEMANA']) {
          case 0:
            obj['NUM_DIA_SEMANA'] = 'Domingo'
            break
          case 1:
            obj['NUM_DIA_SEMANA'] = 'Segunda-feira'
            break
          case 2:
            obj['NUM_DIA_SEMANA'] = 'Terça-feira'
            break
          case 3:
            obj['NUM_DIA_SEMANA'] = 'Quarta-feira'
            break
          case 4:
            obj['NUM_DIA_SEMANA'] = 'Quinta-feira'
            break
          case 5:
            obj['NUM_DIA_SEMANA'] = 'Sexta-feira'
            break
          case 6:
            obj['NUM_DIA_SEMANA'] = 'Sábado'
            break
        }
        return obj
      })
    },
    chartData() {
      return {
        labels: [...this.dataFormatada.map((object) => object['NUM_DIA_SEMANA'])],
        datasets: [
          {
            label: 'Cupons',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.dataFormatada.map((object) => object['NUM_TOTAL_CUPONS'])],
            fill: false,
          },
        ],
      }
    },
  },
}
</script>
